import Vue from 'vue'
import GlobalComponents from '@/globalComponents'

export default Vue.use(GlobalComponents)
